interface KeyboardState {
    pressedKey: string;
}

// TODO: type this — Vuex dispatch/commit types
type AnyDispatch = (...args: any[]) => any;
type AnyCommit = (...args: any[]) => any;

const state: KeyboardState = {
    pressedKey: '',
};

const mutations = {
    keyPressed(state: KeyboardState, key: string): void {
        state.pressedKey = key;
    },
};

let dispatchTrackKeys: ((event: KeyboardEvent) => void) | undefined;
let dispatchFocusActive: ((event: FocusEvent) => void) | undefined;
let dispatchFocusInactive: ((event: FocusEvent) => void) | undefined;

const actions = {
    triggerComplete({ commit }: { commit: AnyCommit }): void {
        commit('keyPressed', '');
    },
    trackKeys({ commit }: { commit: AnyCommit }, event: KeyboardEvent): void {
        commit('keyPressed', event.key);
    },
    focusActive(): void {
        if (dispatchTrackKeys) document.removeEventListener('keyup', dispatchTrackKeys);
    },
    focusInactive(): void {
        if (dispatchTrackKeys) document.addEventListener('keyup', dispatchTrackKeys);
    },
    initiateFunctions({ dispatch }: { dispatch: AnyDispatch }): void {
        dispatchFocusActive = (event: FocusEvent) => dispatch('focusActive', event);
        dispatchFocusInactive = (event: FocusEvent) => dispatch('focusInactive', event);
        dispatchTrackKeys = (event: KeyboardEvent) => dispatch('trackKeys', event);
    },
    addTracking({ dispatch }: { dispatch: AnyDispatch }): void {
        dispatch('initiateFunctions');
        if (dispatchFocusActive) document.addEventListener('focusin', dispatchFocusActive);
        if (dispatchFocusInactive) document.addEventListener('focusout', dispatchFocusInactive);
        if (dispatchTrackKeys) document.addEventListener('keyup', dispatchTrackKeys);
    },
    removeTracking(): void {
        if (dispatchFocusActive) document.removeEventListener('focusin', dispatchFocusActive);
        if (dispatchFocusInactive) document.removeEventListener('focusout', dispatchFocusInactive);
        if (dispatchTrackKeys) document.removeEventListener('keyup', dispatchTrackKeys);
    },
};

const KeyboardStore = {
    namespaced: true,
    state,
    mutations,
    actions,
};

export default KeyboardStore;
